import { render, staticRenderFns } from "./paginacion.vue?vue&type=template&id=59267d73"
import script from "./paginacion.vue?vue&type=script&lang=js"
export * from "./paginacion.vue?vue&type=script&lang=js"
import style0 from "./paginacion.vue?vue&type=style&index=0&id=59267d73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports